import type { IconDefinition } from '../index.tsx';

export const iconArrowUp: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconArrowUp',
  icon: [
    16,
    16,
    [],
    '',
    'M6 8L2 8L2 6L8 5.24536e-07L14 6L14 8L10 8L10 16L6 16L6 8Z',
  ],
};
